var useFirstVisit = function useFirstVisit() {
  if (__IS_SSR__) return true;
  var isFirstVisit = !sessionStorage.getItem('useFirstVisit');
  if (isFirstVisit) {
    sessionStorage.setItem('useFirstVisit', 'false');
  }
  return isFirstVisit;
};
export default useFirstVisit;